import { E_REQUEST_METHOD } from '../ServicesHelpers';
import { API_ENDPOINT } from '../constants';
import { serviceCreator } from 'src/services/helpers/serviceCreator';
export var usersServices = {
    fetchUsers: function (realm, queryParam) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.USERS.SEARCH(realm, queryParam), true, { enableDefaultEvents: true });
    },
    exportUsersInCSV: function (realm) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.USERS.USERS_CSV_EXPORT(realm), true, { headers: { accept: '*/*' } });
    },
    importUsers: function (realm, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.USERS.USERS_CSV_IMPORT(realm), true, {
            data: payload,
            headers: {
                'Content-Type': 'multipart/form-data; boundary=----',
            },
        });
    },
    fetchUserDetails: function (realm, userId) {
        return serviceCreator(E_REQUEST_METHOD.GET, API_ENDPOINT.USERS.USER_DETAILS(realm, userId), true, {
            enableDefaultEvents: true,
        });
    },
    updateUser: function (realm, payload) {
        return serviceCreator(E_REQUEST_METHOD.POST, API_ENDPOINT.USERS.UPDATE_USER(realm), true, {
            data: payload,
        });
    },
    deleteUser: function (realm, userId) {
        return serviceCreator(E_REQUEST_METHOD.DELETE, API_ENDPOINT.USERS.DELETE_USER(realm, userId), true);
    },
};
